module.exports = __webpack_public_path__ + "img/tfsb4.81fd5d3d.png";